import { TextField } from '@mui/material';
import styled from 'styled-components';
import COLORS from '../../colors';
import { ChangeEvent } from 'react';

interface InputProps {
  label: string;
  helperText?: string;
  defaultValue?: string;
  value?: string;
  error?: boolean;
  disabled?: boolean;
  multiline?: boolean;
  required?: boolean;
  onChange?: (value: string) => void;
}

const StyledTextField = styled(TextField)`
  margin-bottom: 16px;

  input {
    color-scheme: dark;
  }

  & .MuiOutlinedInput-root {
    color: ${COLORS.WHITE};

    & fieldset {
      border-color: ${COLORS.NEUTRAL_700};
    }
    &:hover fieldset {
      border-color: ${COLORS.NEUTRAL_500};
    }
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      color: ${COLORS.PRIMARY_500};
      border-color: ${COLORS.PRIMARY_500};
      border-width: 3px;
    }
    &.Mui-error .MuiOutlinedInput-notchedOutline {
      color: ${COLORS.ERROR};
      border-color: ${COLORS.ERROR};
      border-width: 3px;
    }
    &.Mui-disabled .MuiOutlinedInput-notchedOutline {
      color: ${COLORS.NEUTRAL_700};
      border-color: ${COLORS.NEUTRAL_700};
    }
  }

  & .MuiInputLabel-root {
    color: ${COLORS.NEUTRAL_500};

    &.Mui-focused {
      color: ${COLORS.PRIMARY_500};
    }

    &.Mui-error {
      color: ${COLORS.ERROR};
    }

    &.Mui-disabled {
      color: ${COLORS.NEUTRAL_700};
    }
  }

  & .MuiFormHelperText-root {
    color: ${COLORS.NEUTRAL_500};

    &.Mui-error {
      color: ${COLORS.ERROR};
    }

    &.Mui-disabled {
      color: ${COLORS.NEUTRAL_700};
    }
  }
`;

const Input = ({
  label,
  helperText,
  defaultValue,
  value,
  error = false,
  disabled = false,
  multiline = false,
  required = false,
  onChange
}: InputProps) => {
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <StyledTextField
      label={label}
      helperText={helperText}
      defaultValue={defaultValue}
      value={value}
      onChange={handleOnChange}
      fullWidth
      error={error}
      disabled={disabled}
      multiline={multiline}
      rows={multiline ? 4 : undefined}
      required={required}
    />
  );
};

export default Input;
